import { Button } from "react-bootstrap";

import { modalActions } from "../../constants";

const modalSubmitText = (action) => {
	switch (action) {
		case modalActions.CREATE:
			return "Submit";
		case modalActions.DELETE:
			return "Delete";
		case modalActions.MULTI_CREATE:
			return "Submit";
		case modalActions.UPDATE:
		default:
			return "Save Changes";
	}
};

export const EditorButtons = ({
	editorSetting,
	currentModalData = [{}],
	handleFormSubmit = () => console.log,
}) => {
	const DefaultEditorButton = () => (
		<Button
			variant="primary"
			className="ms-1"
			onClick={handleFormSubmit(editorSetting?.apiFunctionSubmit)}
		>
			{editorSetting?.submitButtonText ||
				(editorSetting?.formatSubmitButtonText &&
					editorSetting.formatSubmitButtonText(
						currentModalData[0],
					)) ||
				modalSubmitText(editorSetting?.action)}
		</Button>
	);

	const fnData =
		editorSetting?.action === modalActions.MULTI_CREATE
			? currentModalData
			: currentModalData[0];

	return (
		<div className="ms-auto" data-testid="test-editorButtons">
			{editorSetting?.buttons ? (
				editorSetting.buttons.map(
					(
						{ handleIsVisible, isDefault, handleSubmit, text },
						index,
					) => {
						if (
							handleIsVisible === undefined ||
							(handleIsVisible && handleIsVisible(fnData))
						) {
							if (isDefault) {
								return (
									<DefaultEditorButton
										key={`editorButton-${index}`}
									/>
								);
							}

							return (
								<Button
									key={`editorButton-${index}`}
									variant="primary"
									onClick={handleFormSubmit(handleSubmit)}
									className="ms-1"
								>
									{text || "Save Changes"}
								</Button>
							);
						}
						return null;
					},
				)
			) : (
				<DefaultEditorButton />
			)}
		</div>
	);
};
